import { render, staticRenderFns } from "./dougongpayment.vue?vue&type=template&id=9115befe&scoped=true"
import script from "./dougongpayment.vue?vue&type=script&lang=js"
export * from "./dougongpayment.vue?vue&type=script&lang=js"
import style0 from "./dougongpayment.vue?vue&type=style&index=0&id=9115befe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9115befe",
  null
  
)

export default component.exports